module.exports = __webpack_public_path__ + "static/img/place_6.886befb3.png";